import React, { FC } from "react";
import { Rect } from "react-konva";
import { DEFAULT_LARGHEZZA_GUARNIZIONE, DEFAULT_STROKE_WIDTH } from "../../../../../../../core/common_constants";
import { toDrawUnit } from "../../../../../../../core/common_functions";
import { NullableString } from "../../../../../../../core/common_types";
import { getStrokeColor } from "../draw_utils";

export const Guarnizione: FC<{x: number, y: number, length: number, rotation: number, colorCode?: NullableString}> = ({x, y, length, rotation, colorCode}) => {

    return (
        <Rect
            x={x}
            y={y}
            width={toDrawUnit(DEFAULT_LARGHEZZA_GUARNIZIONE)}
            height={length}
            stroke={getStrokeColor(colorCode)}
            strokeWidth={0.25}
            fill={"#000"}
            rotation={rotation}
        />
    );
}